module.exports = __webpack_public_path__ + "assets/img/23_196.aa20ce42.jpg";